import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { HowToProvideDocs } from './HowToProvideDocs';

interface Props {
	className?: string;
	onClose: () => void;
	requestCertifiedCopiesOfDocuments?: boolean;
}

export const HowTopProvideDocsModal = ({
	onClose,
	className,
	requestCertifiedCopiesOfDocuments,
}: Props) => {
	return (
		<Modal className={className} onClose={onClose} size="md">
			<HowToProvideDocs
				requestCertifiedCopiesOfDocuments={requestCertifiedCopiesOfDocuments}
			/>
		</Modal>
	);
};
